import React from 'react';
import { Button, Col, ConfigProvider, Form, Input, InputNumber, Modal, Row, Select, Typography, Alert } from 'antd';
import locale from "antd/es/locale/es_ES";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { PostProjecteClonar } from "../../../dao/abp/PostProjecteClonar";

interface Props {
    element: object;
    visible: boolean;
    id_projecte: string;
    data: any[];
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const CopiarProjecteModal: React.FC<Props> = (props: Props) => {
    const [form] = Form.useForm();
    const { Title } = Typography;

    async function handleSubmit() {
        try {
            const formData = await form.validateFields();
            console.log("Form Data:", formData);

            await PostProjecteClonar(props.id_projecte, formData.id_projecte, formData.sprint);

            props.onClose(true);
        } catch (error) {
            console.error("Validation Failed:", error);
        }
    }

    const handleCancel = () => {
        props.onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title={<Title level={4} style={{ margin: 0 }}>Copiar Projecte</Title>}
                open={props.visible}
                onCancel={handleCancel}
                onOk={handleSubmit}
                width={500}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel·lar
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        onClick={handleSubmit}
                        style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                    >
                        Copiar
                    </Button>,
                ]}
            >
                <Form
                    form={form}
                    initialValues={props.element}
                    onFinish={handleSubmit}
                    layout="vertical"
                    style={{ marginTop: 24 }}
                >
                    <Alert
                        message="Atenció"
                        description="Copiar un projecte elimina totes les tasques sense RA assignat!"
                        type="warning"
                        showIcon
                        style={{ marginBottom: 24 }}
                    />

                    <Form.Item label="Selecciona Projecte Origen" name="id_projecte"
                        rules={[{ required: true, message: 'Selecciona un projecte' }]}>
                        <Select
                            showSearch
                            placeholder="Cerca i selecciona un projecte"
                            optionFilterProp="label"
                            options={props.data}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>

                    <Form.Item label="Sprint Destí" name="sprint"
                        rules={[{ required: true, message: 'Introdueix el sprint' }]}>
                        <InputNumber
                            min={0}
                            max={99}
                            step={1}
                            defaultValue={0}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default CopiarProjecteModal;
